<template>
    <div>
        <HeaderPage href="/companynews" />
        <div class="container_wrap information">
            <div class="neiBanner">
                <div class="textBanner wow">
                    <dl>INFORMATION DISCLOSURE</dl>
                    <div class="solid"></div>
                    <dt>{{title}}</dt>
                </div>
            </div>
            <div class="box wow">
                <!-- 加载状态 -->
                <div class="loading" v-if="loading">
                    <p>数据加载中...</p>
                </div>
                <!-- 数据列表 -->
                <ul v-else-if="currentPageData.length">
                    <li v-for="(data) in currentPageData" :key="data.id">
                        <router-link :to="`/companynews/detail?type=${data.type}&title=${data.name}`">
                            <h3>{{data.name}}</h3>
                            <ol>
                                <dl>{{ data.datePrefix }}</dl>
                                <span>{{ data.day }}</span>
                            </ol>
                        </router-link>
                    </li>
                </ul>
                <!-- 无数据提示 -->
                <div class="no-data" v-else>暂无数据</div>
            </div>

            <!-- 分页组件（核心） -->
            <Pagination
                :total-count="totalCount"
                :page-size="pageSize"
                v-model:currentPage="currentPage"
                @page-change="fetchData"
            />
                            
        </div>

        <FooterPage />
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed, watch} from 'vue';
import { useRoute } from 'vue-router';
import { getWebsiteData } from '@/utils/api';
// 组件逻辑
import HeaderPage from '@/components/HeaderPage.vue'
import FooterPage from '@/components/FooterPage.vue'
import Pagination from '@/components/PaginationModel.vue'

const route = useRoute();

const id = ref(Number(route.query.id) || 3); 

// 监听路由变化，更新id
watch(() => route.query.id, (newId) => {
  if (newId) {
    id.value = Number(newId);
    currentPage.value = 1; // 重置页码
    fetchData(); // 重新获取数据
  }
});


const title = ref('安全评价报告信息公开')

// 1. 数据状态：原始总数据、分页相关状态
const pDataList = ref([]); // 接口返回的数据列表
const currentPage = ref(1); // 当前页码（默认第1页）
const pageSize = ref(12); // 每页显示10条（与接口保持一致）
const totalCount = ref(0); // 总数据量（从接口获取）
const loading = ref(false); // 加载状态


// 处理显示数据：将接口数据转换为页面需要的格式
const currentPageData = computed(() => {
    return pDataList.value.map(item => {
        // 假设接口返回的时间字段需要处理，根据实际接口调整
        let datePrefix = '';
        let day = '';
        
        // 如果接口有时间字段，进行处理
        if (item.releaseTime) {
            const timeStr = item.releaseTime;
            const date = new Date(timeStr);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const dayNum = String(date.getDate()).padStart(2, '0');
            datePrefix = `${year}-${month}`;
            day = dayNum;
        }
        
        return {
            id: item.id,
            name: item.title, // 使用title作为name
            type: item.type,
            datePrefix,
            day
        };
    });
});



// 获取数据的方法
const fetchData = async () => {
    try {
        loading.value = true; 
        const params = {
            pageNo: currentPage.value,
            pageSize: pageSize.value,
            // 如果需要根据type筛选，可以添加type参数
            type: id.value
        };
        
        const response = await getWebsiteData(params);
       
        // 根据接口返回格式处理数据
        if (response && response.data) {
            title.value =  response.data.list[0].typeName
            pDataList.value = response.data.list || [];
            totalCount.value = response.data.total || 0;
        }
    } catch (error) {
        console.error('获取数据失败：', error);
        pDataList.value = [];
        totalCount.value = 0;
    } finally {
        loading.value = false;
    }
};

// 监听页码变化，重新获取数据
watch(currentPage, () => {
    fetchData();
});

let intervalId

const stopAutoScroll = () => {
    clearInterval(intervalId)
}

onMounted(async () => {
    // 初始化获取数据
    await fetchData();

    // ✅ 滚动动画逻辑
    const elements = document.querySelectorAll('.wow')
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                const el = entry.target
                const animateName = el.dataset.animate || 'fadeInUp'
                if (entry.isIntersecting) {
                    el.classList.add('animated', animateName)
                    // ✅ 添加后立即取消观察，避免重复触发
                    observer.unobserve(el)
                }
            })
        },
        { threshold: 0.2 }
    )
    elements.forEach((el) => observer.observe(el))
    onUnmounted(() => {
        elements.forEach((el) => observer.unobserve(el))
        stopAutoScroll()
    })
})
</script>

<style scoped>
.neiBanner {
    height: 320px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    background: url('@/assets/images/bg/informationBg.jpg') no-repeat center;
}

.neiBanner .textBanner {
    color: #fff;
    text-align: center;
}

.neiBanner .textBanner dl {
    font-size: 42px;
    color: #003366;
}

.neiBanner .textBanner dt {
    font-size: 30px;
    color: #000;
}

.solid {
    background-color: #003366;
    height: 1px;
    margin: 10px 0;
}

ul {
    width: 100%;
}

/* 分页样式（核心新增） */
.pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    margin: 30px 0;
    padding: 10px;
}
.page-info {
    color: #666;
    font-size: 14px;
}
.page-buttons {
    display: flex;
    gap: 8px;
}
.page-btn {
    padding: 5px 12px;
    border: 1px solid #ddd;
    background-color: #fff;
    color: #333;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.2s;
}
.page-btn:disabled {
    cursor: not-allowed;
    color: #999;
    background-color: #f5f5f5;
    border-color: #eee;
}
.page-btn.number.active {
    background-color: #003366;
    color: #fff;
    border-color: #003366;
}
.page-btn:hover:not(:disabled) {
    border-color: #003366;
    color: #003366;
}

/* 加载状态样式 */
.loading {
    text-align: center;
    padding: 50px 0;
    color: #666;
    font-size: 16px;
}

.no-data {
    text-align: center;
    padding: 50px 0;
    color: #999;
    font-size: 16px;
}
</style>